module.exports = __webpack_public_path__ + "static/media/hand-holding-heart.b1cb864e.svg";